module.exports = __webpack_public_path__ + "img/clock-exclamation.10fbaaa1.svg";